<form
  [formGroup]="editPolicyForm" 
  name="editPolicyForm"
  (ngSubmit)="editPolicyForm.valid && editPolicy()">
  <div class="">
      <div *ngFor="let input of inputs; index as index" class="input" [ngClass]="{'first-input': input.key === 'editFirst_name' , 'second-input': input.key === 'editMI_name'}">
      <mapfre-validation [input]="input" [form]="editPolicyForm"></mapfre-validation>
    </div>
  </div>
  <div class="row margin-top mt24 text-center">
    <div class="col">
      <mapfre-button [ngClass]="{'custom_loader':loader}"
        [additionalClasses]="'basic primary large-btn'"
        [disabledValue]="editPolicyForm.valid && !loader" 
        [inputType]="'submit'"
        [translateValue]="'CONFIRM' | translate"
      ></mapfre-button>
    </div>
  </div>
</form>